import {
    additionalTableHeaderIds,
    agentsArrayColumns,
    agentsColumnsOfficeBreakdown,
    agentsParentColumns,
    officeInformationArrayColumns,
    officeInformationColumnsOfficeBreakdown,
    officeNameColumn,
    potentialImpactArrayColumns
} from '../../../../agent-production/agent-movement/tableSettings';
import { tableViewNames } from '../../../../agent-production/constants/agentProductionConstants';
import { getAdditionalTableHeader } from '../agGrid/agGrid';

export const getAgentMovementTableView = ({ defaultSort }) =>
    Object.freeze({
        id: tableViewNames.agentMovement,
        defaultSort,
        tables: [
            { children: [ officeNameColumn ] },
            {
                headerGroupTitle: (props) =>
                    getAdditionalTableHeader(additionalTableHeaderIds.officeInformation, props),
                children: officeInformationArrayColumns(false)
            },
            {
                headerGroupTitle: (props) =>
                    getAdditionalTableHeader(additionalTableHeaderIds.agents, props),
                children: agentsArrayColumns
            },
            {
                headerGroupTitle: (props) =>
                    getAdditionalTableHeader(additionalTableHeaderIds.potentialImpact, props),
                children: potentialImpactArrayColumns
            }
        ]
    });

    export const getOfficeBreakdownTableView = shouldShowAdditionalInfo =>
        Object.freeze({
            id: tableViewNames.officeBreakdown,
            defaultSort: { colId: agentsParentColumns.agentsLost.id, sortDir: 'desc' },
            tables: [
                {
                    headerGroupTitle: (props) =>
                        getAdditionalTableHeader(additionalTableHeaderIds.officeInformation, props),
                    children: officeInformationColumnsOfficeBreakdown(shouldShowAdditionalInfo)
                },
                {
                    headerGroupTitle: (props) =>
                        getAdditionalTableHeader(additionalTableHeaderIds.agents, props),
                    children: agentsColumnsOfficeBreakdown
                },
                {
                    headerGroupTitle: (props) =>
                        getAdditionalTableHeader(additionalTableHeaderIds.potentialImpact, props),
                    children: potentialImpactArrayColumns
                }
            ]
        });
